import React, { useState } from 'react';

const FAQSection = () => {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (index) => {
    setOpenItems(prev => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const faqData = [
    {
      question: 'Сколько времени нужно для запуска магазина?',
      answer: 'Стандартный запуск магазина занимает от 3 до 7 рабочих дней в зависимости от маркетплейса и количества товаров. Мы берём на себя все этапы: от регистрации до загрузки первых карточек товаров.',
    },
    {
      question: 'На каких маркетплейсах вы работаете?',
      answer: 'Мы работаем с тремя крупнейшими площадками: Wildberries, Ozon и Яндекс Маркет. Можем вести магазины параллельно на всех платформах в рамках одного тарифа «Премиум».',
    },
    {
      question: 'Что входит в ежемесячное обслуживание?',
      answer: 'В зависимости от тарифа: управление рекламными кампаниями, SEO-оптимизация карточек, аналитика продаж, работа с отзывами, ценообразование, A/B тестирование и регулярная отчётность.',
    },
    {
      question: 'Гарантируете ли вы результат?',
      answer: 'Да, на тарифе «Премиум» мы предоставляем гарантию результата. На остальных тарифах мы прописываем KPI в договоре и ежемесячно отчитываемся о достижении целевых показателей.',
    },
    {
      question: 'Могу ли я сменить тариф в процессе работы?',
      answer: 'Конечно. Вы можете перейти на более высокий или более низкий тариф в любой момент. Перерасчёт происходит с начала следующего расчётного периода.',
    },
    {
      question: 'Нужно ли мне самому что-то делать?',
      answer: 'Минимально. Мы берём на себя всю операционную работу. От вас потребуется только согласование ключевых решений и предоставление информации о товарах на старте.',
    },
    {
      question: 'Как быстро я увижу первые результаты?',
      answer: 'Первые результаты обычно заметны через 2-4 недели после запуска. Стабильный рост продаж формируется к 2-3 месяцу работы, когда карточки набирают позиции и отзывы.',
    },
    {
      question: 'Работаете ли вы с новыми брендами без истории продаж?',
      answer: 'Да, это одно из наших ключевых направлений. Мы запустили более 6000 магазинов с нуля и имеем отработанную методологию вывода новых брендов в топ.',
    },
    {
      question: 'Как устроена отчётность?',
      answer: 'В зависимости от тарифа — еженедельные или ежедневные отчёты. Включают: динамику продаж, расходы на рекламу, позиции в поиске, конверсии карточек, ROI рекламных кампаний. Доступ к дашборду 24/7.',
    },
    {
      question: 'Какой минимальный бюджет на рекламу нужен?',
      answer: 'Рекомендуемый рекламный бюджет зависит от ниши и конкуренции. Обычно от 30 000 ₽/мес на одну площадку. На бесплатной консультации мы рассчитаем оптимальный бюджет под ваши цели.',
    },
    {
      question: 'Можно ли заказать только одну услугу, например, только рекламу?',
      answer: 'Да, мы можем работать по отдельным направлениям: только реклама, только контент, только аналитика. Но комплексный подход даёт значительно лучшие результаты, поэтому рекомендуем пакетные тарифы.',
    },
    {
      question: 'Как начать сотрудничество?',
      answer: 'Оставьте заявку на сайте или напишите нам в Telegram. Мы проведём бесплатную онлайн-презентацию, проанализируем вашу нишу и предложим оптимальную стратегию продвижения.',
    },
  ];

  const renderFaqItem = (item, index) => (
    <div
      key={index}
      className={`faq-item ${openItems.has(index) ? 'active' : ''}`}
    >
      <div className="faq-question" onClick={() => toggleItem(index)}>
        <h3 className="faq-question-text">{item.question}</h3>
        <div className="faq-icon">
          <span className="faq-icon-h" />
          <span className="faq-icon-v" />
        </div>
      </div>
      <div className="faq-answer">
        <p>{item.answer}</p>
      </div>
    </div>
  );

  return (
    <section id="faq" className="faq-section">
      {/* Декоративные элементы на фоне */}
      <div className="faq-bg-decor">
        {/* Градиентные круги */}
        <div className="faq-glow faq-glow-2" />

        {/* Декоративные иконки */}
        <img
                loading="lazy"
          src="/images/icons/rocket.webp"
          alt=""
          className="faq-bg-icon faq-bg-icon-1"
        />
        <img
                loading="lazy"
          src="/images/icons/analytics.webp"
          alt=""
          className="faq-bg-icon faq-bg-icon-2"
        />
        <img
                loading="lazy"
          src="/images/icons/chart.webp"
          alt=""
          className="faq-bg-icon faq-bg-icon-3"
        />
        <img
                loading="lazy"
          src="/images/icons/star.webp"
          alt=""
          className="faq-bg-icon faq-bg-icon-4"
        />
      </div>

      <div className="faq-container">
        <h2 className="faq-title">ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ</h2>
        <p className="faq-subtitle">Ответы на популярные вопросы о наших услугах</p>

        <div className="faq-grid">
          <div className="faq-column">
            {faqData.slice(0, 6).map((item, i) => renderFaqItem(item, i))}
          </div>
          <div className="faq-column">
            {faqData.slice(6, 12).map((item, i) => renderFaqItem(item, i + 6))}
          </div>
        </div>
      </div>

      <style>
        {`
          .faq-section {
            background: #0F0F1A;
            padding: 100px 0;
            position: relative;
            overflow: hidden;
          }

          /* Декоративные элементы на фоне */
          .faq-bg-decor {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
            z-index: 0;
          }

          .faq-glow {
            position: absolute;
            border-radius: 50%;
            filter: blur(100px);
          }

          .faq-glow-1 {
            width: 400px;
            height: 400px;
            top: -100px;
            left: -150px;
            background: linear-gradient(135deg, #22D3EE, #8B5CF6);
            opacity: 0.08;
          }

          .faq-glow-2 {
            width: 450px;
            height: 450px;
            bottom: -150px;
            right: -150px;
            background: linear-gradient(135deg, #EC4899, #FBBF24);
            opacity: 0.06;
          }

          .faq-bg-icon {
            position: absolute;
            opacity: 0.05;
            filter: blur(1px) grayscale(0.3);
          }

          .faq-bg-icon-1 {
            width: 100px;
            height: 100px;
            top: 10%;
            left: 5%;
            transform: rotate(-15deg);
            animation: floatFaq1 7s ease-in-out infinite;
          }

          .faq-bg-icon-2 {
            width: 100px;
            height: 100px;
            top: 15%;
            right: 8%;
            transform: rotate(12deg);
            animation: floatFaq2 8s ease-in-out infinite;
          }

          .faq-bg-icon-3 {
            width: 100px;
            height: 100px;
            bottom: 20%;
            left: 8%;
            transform: rotate(8deg);
            animation: floatFaq3 6s ease-in-out infinite;
          }

          .faq-bg-icon-4 {
            width: 100px;
            height: 100px;
            bottom: 15%;
            right: 6%;
            transform: rotate(-10deg);
            animation: floatFaq4 9s ease-in-out infinite;
          }

          @keyframes floatFaq1 {
            0%, 100% { transform: rotate(-15deg) translateY(0); }
            50% { transform: rotate(-15deg) translateY(-12px); }
          }

          @keyframes floatFaq2 {
            0%, 100% { transform: rotate(12deg) translateY(0); }
            50% { transform: rotate(12deg) translateY(-10px); }
          }

          @keyframes floatFaq3 {
            0%, 100% { transform: rotate(8deg) translateY(0); }
            50% { transform: rotate(8deg) translateY(-14px); }
          }

          @keyframes floatFaq4 {
            0%, 100% { transform: rotate(-10deg) translateY(0); }
            50% { transform: rotate(-10deg) translateY(-8px); }
          }

          .faq-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
            position: relative;
            z-index: 1;
          }

          .faq-title {
            font-family: 'Inter', sans-serif;
            font-size: 48px;
            font-weight: 900;
            text-transform: uppercase;
            color: #FFFFFF;
            text-align: center;
            letter-spacing: -0.02em;
            margin: 0 0 16px 0;
          }

          .faq-subtitle {
            font-family: 'Inter', sans-serif;
            font-size: 18px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.45);
            text-align: center;
            margin: 0 0 60px 0;
          }

          .faq-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
            align-items: start;
          }

          .faq-column {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          .faq-item {
            background: rgba(255, 255, 255, 0.04);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 16px;
            overflow: hidden;
            transition: border-color 0.3s ease, background 0.3s ease;
          }

          .faq-item:hover {
            border-color: rgba(255, 255, 255, 0.15);
            background: rgba(255, 255, 255, 0.06);
          }

          .faq-item.active {
            border-color: rgba(255, 255, 255, 0.12);
            background: rgba(255, 255, 255, 0.06);
          }

          .faq-question {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 22px 24px;
            cursor: pointer;
            user-select: none;
          }

          .faq-question-text {
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 1.4;
            padding-right: 16px;
            margin: 0;
          }

          .faq-icon {
            width: 24px;
            height: 24px;
            position: relative;
            flex-shrink: 0;
          }

          .faq-icon-h,
          .faq-icon-v {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 14px;
            height: 2px;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 1px;
            transition: transform 0.3s ease, opacity 0.3s ease, background 0.3s ease;
          }

          .faq-icon-h {
            transform: translate(-50%, -50%);
          }

          .faq-icon-v {
            transform: translate(-50%, -50%) rotate(90deg);
          }

          .faq-item.active .faq-icon-h,
          .faq-item.active .faq-icon-v {
            background: linear-gradient(135deg, #00D4FF, #FF2D7C);
          }

          .faq-item.active .faq-icon-v {
            transform: translate(-50%, -50%) rotate(0deg);
            opacity: 0;
          }

          .faq-answer {
            max-height: 0;
            overflow: hidden;
            opacity: 0;
            transition: max-height 0.4s ease, padding 0.4s ease, opacity 0.3s ease;
            padding: 0 24px;
          }

          .faq-item.active .faq-answer {
            max-height: 300px;
            opacity: 1;
            padding: 0 24px 24px;
          }

          .faq-answer p {
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.55);
            line-height: 1.65;
            margin: 0;
          }

          @media (max-width: 768px) {
            .faq-section {
              padding: 60px 0;
            }

            .faq-title {
              font-size: 36px;
            }

            .faq-grid {
              grid-template-columns: 1fr;
            }

            .faq-question {
              padding: 18px 20px;
            }

            .faq-answer {
              padding: 0 20px;
            }

            .faq-item.active .faq-answer {
              padding: 0 20px 20px;
            }
          }

          @media (max-width: 480px) {
            .faq-title {
              font-size: 28px;
            }

            .faq-subtitle {
              font-size: 16px;
            }

            .faq-question-text {
              font-size: 15px;
            }

            .faq-answer p {
              font-size: 14px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default FAQSection;
